import AppRoutes from './routes/AppRoutes.jsx';

export default function App() {
  return <AppRoutes />;
}
